import React, { useState, useEffect, forwardRef } from "react";
import { Box, Typography } from "@mui/material";
import DecorativeImage from "../assets/loading.png";
import gsap from "gsap";

// Forwarding the ref for GSAP animation
const LoadingScreen = forwardRef((props, ref) => {
  const [showImage, setShowImage] = useState(true);
  const [animationComplete, setAnimationComplete] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [containerFadeOut, setContainerFadeOut] = useState(false);
  const fullText = "The Farm Stories";

  useEffect(() => {
    if (showImage && !animationComplete) {
      gsap.fromTo(
        ".text-element span",
        {
          opacity: 0,
          y: 30,
        },
        {
          opacity: 1,
          y: 0,
          delay: 1.5,
          duration: 1,
          ease: "power3.out",
          stagger: 0.1,
          onComplete: () => {
            setAnimationComplete(true);
            setTimeout(() => {
              setFadeOut(true);
              setContainerFadeOut(true);
            }, 1000);
          },
        }
      );
    }

    if (fadeOut) {
      gsap.to(".fade-out", {
        opacity: 0,
        duration: 1,
        ease: "power3.out",
        onComplete: () => {
          setShowImage(false);
        },
      });
    }

    if (containerFadeOut) {
      gsap.to(".background", {
        opacity: 0,
        scale: 1,
        duration: 3,
        ease: "power3.out",
      });
      gsap.to(".fade-out", {
        opacity: 0,
        scale: 1,
        duration: 2,
        ease: "power3.out",
      });
    }
  }, [showImage, animationComplete, fadeOut, containerFadeOut]);

  return (
    <Box
      ref={ref} // Forward the ref to the container for GSAP manipulation
      sx={{
        backgroundColor: "#F7EEE6",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        transition: "opacity 2s ease-out",
      }}
      className="background"
    >
      <Box
        className="fade-out"
        sx={{
          width: "200px",
          height: "267px",
          borderRadius: "219px 219px 0px 0px",
          backgroundColor: "#FFFFFF",
          opacity: 1,
          position: "relative",
          animation: "zoomOut 1s ease-in-out",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            width: "100%",
            position: "absolute",
            top: "10%",
            padding: "0 15%",
          }}
        >
          <Box
            component="img"
            src={DecorativeImage}
            alt="Decorative"
            className="reveal-image"
            sx={{
              width: "25%",
              height: "50%",
              position: "relative",

              transition: "opacity 1s ease-in-out",
              opacity: showImage ? 1 : 0,
            }}
          />
          <Typography
            className="text-element"
            sx={{
              fontFamily: "ZapfHumnst BT, sans-serif",
              fontSize: "35px",
              fontWeight: 400,
              lineHeight: "29px",
              textAlign: "left",
              textUnderlinePosition: "from-font",
              textDecorationSkipInk: "none",
              position: "relative",
              marginLeft: "10px",
              color: "#886F58",
              display: "inline-block",
            }}
          >
            {showImage &&
              fullText
                .split("")
                .map((char, index) => <span key={index}>{char}</span>)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
});

export default LoadingScreen;
